import { forwardRef } from "react";
import { Link, type LinkProps as RouterLinkProps } from "react-router";

type Props = Omit<RouterLinkProps, "to"> & { href: RouterLinkProps["to"] };

export const CustomLink = forwardRef<HTMLAnchorElement, Props>((props, ref) => {
  const { href, ...other } = props;
  return <Link ref={ref} to={href} {...other} />;
});
